import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Manual from "./Manual";
//import Actions from "./components/Actions";
//import TabPanel from "./components/Tab"
function ManualPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <br />
      <MDBox borderRadius="lg" coloredShadow="info" py={0.01}>
            <Manual/>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
export default ManualPage;
